const createStore = <T>(initialState: T) => {
  let state = initialState;
  const listeners = new Set<() => void>();

  const setState = (fn: (prevState: T) => T) => {
    const newState = fn(state);
    if (newState !== state) {
      state = newState;
      listeners.forEach((listener) => listener());
    }
  };

  const getSnapshot = () => state;

  const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  };

  const getServerSnapshot = () => state;

  return {
    setState,
    getSnapshot,
    subscribe,
    getServerSnapshot,
  };
};

export default createStore;
